import { Component } from 'react';

import { Box } from '@mui/material';

export default class ProjectDescription extends Component {
  constructor(props) {
    super(props);
    
    const item = props.item;
    const description = item.description;
    const situation = item.situation;
    this.state = {
      description,
      situation
    }
  }

  render() {
    const {
      description,
      situation
    } = this.state;

    return (
      <Box className='project-info'>
        <Box className='description'>
          {description}
        </Box>
        <Box className='situation'>
          {situation}
        </Box>
      </Box>
    );
  }
}
